import React, { useState } from "react";
import {
  Rocket,
  Shield,
  MessageSquare,
  FileText,
  Image,
  AlertTriangle,
  ChevronDown,
  ChevronRight,
  Zap,
  Wallet,
} from "lucide-react";

const ICON_MAP = {
  Rocket,
  Shield,
  MessageSquare,
  FileText,
  Image,
  AlertTriangle,
  Zap,
  Wallet,
};

const DocSidebar = ({ categories, activeSection, onSelect }) => {
  const [expanded, setExpanded] = useState(() => {
    const initial = {};
    categories.forEach((c) => { initial[c.id] = true; });
    return initial;
  });

  const toggleCategory = (catId) => {
    setExpanded((prev) => ({ ...prev, [catId]: !prev[catId] }));
  };

  return (
    <nav className="apidocs-nav">
      <div className="apidocs-nav-label">API Reference</div>

      <div className="apidocs-nav-list">
        {categories.map((cat) => {
          const Icon = ICON_MAP[cat.icon] || FileText;
          const isExpanded = expanded[cat.id];
          const hasItems = cat.items && cat.items.length > 0;
          const isSingle = hasItems && cat.items.length === 1;
          const isActive = cat.items?.some((item) => item.id === activeSection);

          if (isSingle) {
            const item = cat.items[0];
            return (
              <button
                key={cat.id}
                type="button"
                onClick={() => onSelect(item.id)}
                className={`apidocs-nav-item ${activeSection === item.id ? "on" : ""}`}
              >
                <Icon size={14} />
                {cat.title}
              </button>
            );
          }

          return (
            <div key={cat.id}>
              <button
                type="button"
                onClick={() => toggleCategory(cat.id)}
                className={`apidocs-nav-item ${isActive && !isExpanded ? "on" : ""}`}
              >
                <Icon size={14} />
                <span className="grow">{cat.title}</span>
                {hasItems && (
                  isExpanded ? <ChevronDown size={12} /> : <ChevronRight size={12} />
                )}
              </button>

              {isExpanded && hasItems && (
                <div className="apidocs-nav-sub">
                  {cat.items.map((item) => (
                    <button
                      key={item.id}
                      type="button"
                      onClick={() => onSelect(item.id)}
                      className={`apidocs-nav-subitem ${activeSection === item.id ? "on" : ""}`}
                    >
                      {item.title}
                    </button>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </nav>
  );
};

export default DocSidebar;
